import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SharedLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contacto/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contacto/components/ContactInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contacto/components/LocationMap.tsx");
